import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ApiService } 					from  '../api.service';
import { Router} 						from '@angular/router';

@Component({
  selector: 'app-pickup-shipper',
  templateUrl: './pickup-shipper.component.html',
  styleUrls: ['./pickup-shipper.component.css']
})
export class PickupShipperComponent implements OnInit {

  options:any;
    data:any;
    orders:any;

    trackingNumber:any = null;
    resultsLength = 1;
    updateWeight = false;

    submitted = false;

    totalLoaded = 0;
    ordersCount = 0;

    form: FormGroup;
    deliveries: null;

    showTrackingInput = false;
    showWeightInput = false;

    constructor(
        private apiService: ApiService,
        private router: Router,
        private fb: FormBuilder
        ) { }


    get f() { return this.form.controls; }

    ngOnInit() {

        this.form = this.fb.group({
            plate_number: ['', [Validators.required]],
            hub_location_id: ['', [Validators.required]],
            delivery_id: ['',     []],
            tracking_number: ['', []],
            package_weight: ['', [Validators.pattern(/^[.\d]+$/)]],
            // status_id: ['', []],
            // hub_location_id: ['', []],
            // start_date: ['', []],
            // end_date: ['', []],
        });

        setTimeout(()=>{
            document.getElementById("plate_number").focus();
        },0);

        this.index();
    }

    // index(): void {

    //     this.apiService.lazadaPackageSearchOptions().subscribe(data => {

    //         // console.log(data);
    //         this.options 		= data.data;
    //     });
    // }

    index(): void {

        this.apiService.registerOptions().subscribe(data => {

            this.options         = data.data;
        });
    }

    start() {

        this.submitted = true;

        if(this.form.valid) {

            if(this.form.controls['tracking_number'].value !== '' && this.form.controls['package_weight'].value === '' && this.updateWeight)
                setTimeout(()=>{
                    document.getElementById("package_weight").focus();
                },0);
            else {

                this.apiService.outboundTransfer(this.form.getRawValue()).subscribe(data => {

                    if (data.status) {
                        if(this.showTrackingInput)
                            this.totalLoaded++;

                        if('data' in data && 'deliveries' in data.data) {
                            this.deliveries = data.data.deliveries;

                            if(data.data.deliveries.length > 0) {
                                this.form.controls['delivery_id'].setValue(data.data.deliveries[0].id);                                
                            }

                            this.showTrackingInput = true;
                        }

                        if(this.showTrackingInput) {
                            setTimeout(()=>{
                                this.form.controls['tracking_number'].setValue('');
                                this.form.controls['package_weight'].setValue('');
                                this.form.controls['plate_number'].disable();
                                this.form.controls['hub_location_id'].disable();
                                
                                document.getElementById("tracking_number").focus();
                                this.loadTransferOrders(this.form.controls['delivery_id'].value);
                            },0);
                        }
                    }    
                    else {
                        alert(data.message);
                        this.form.controls['tracking_number'].setValue('');
                        this.form.controls['package_weight'].setValue('');

                        setTimeout(()=>{
                            document.getElementById("tracking_number").focus();
                        },0);
                    }
                });
            }
        }
    }

    toggleUpdateWeight(): void {
        this.updateWeight = !this.updateWeight;
        
        if(!this.updateWeight) {
            this.showWeightInput = false;
            this.form.controls['package_weight'].setValue('');
            
            setTimeout(()=>{
                document.getElementById("tracking_number").focus();
            },0);   
        }
        else {
            this.showWeightInput = true;
            
            if(this.form.controls['tracking_number'].value !== '') {
                this.form.controls['package_weight'].setValue('');
                setTimeout(()=>{
                    document.getElementById("package_weight").focus();
                },0);   
            }
            else 
                setTimeout(()=>{
                    document.getElementById("tracking_number").focus();
                },0);   
        }
    }

    onChange(event) {
        this.form.controls['delivery_id'].setValue(event.target.value);

        setTimeout(()=>{
            document.getElementById("tracking_number").focus();
        },0);

        this.showTrackingInput = true;

        if(event.target.value !== '')
            this.loadTransferOrders(event.target.value);
        else {
            this.orders = null
            this.ordersCount = 0;
        }
    }

    onHubChange(event) {
        this.form.controls['hub_location_id'].setValue(event.target.value);

        // setTimeout(()=>{
        //     document.getElementById("tracking_number").focus();
        // },0);

        // this.showTrackingInput = true;

        // if(event.target.value !== '')
        //     this.loadTransferOrders(event.target.value);
        // else {
        //     this.orders = null
        //     this.ordersCount = 0;
        // }
    }

    loadTransferOrders(id):void {

        if(id !== '') {
            this.orders         = null;
            this.ordersCount    = 0;

            this.apiService.outboundTransferOrders(id).subscribe(data => {

                this.orders         = data.data;
                if(this.orders)
                    this.ordersCount    = this.orders.length;
            });
        }
    }

    removeTransferOrder(id):void {

        let self = this;
        this.apiService.outboundTransferRemove(id).subscribe(data => {
            this.totalLoaded--;
            self.loadTransferOrders(this.form.controls['delivery_id'].value);
        });

    }

    finish() {
        this.submitted = false;
        this.showTrackingInput = false

        this.totalLoaded = 0;
        this.deliveries = null;

        this.form.controls['plate_number'].enable();
        this.form.controls['plate_number'].setValue('');
        this.form.controls['hub_location_id'].enable();
        this.form.controls['hub_location_id'].setValue('');
        this.form.controls['delivery_id'].setValue('');
        this.form.controls['tracking_number'].setValue('');
        this.form.controls['package_weight'].setValue('');

        this.data = null;
        this.orders = null;
        this.ordersCount = 0;

        setTimeout(()=>{
            document.getElementById("plate_number").focus();
        },0);
    }
}
